import { useConfirmOrderApi } from 'apis/orders/use-confirm-order-api';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from 'design-system';

interface ConfirmOrderModalProps {
  orderId: number;
  code: string;
  isOpen: boolean;
  onClose: () => void;
}

/** Ops confirm a placed order on the supplier's behalf; the backend moves it to `approved` and pushes the restaurant. */
export const ConfirmOrderModal = ({ orderId, code, isOpen, onClose }: ConfirmOrderModalProps) => {
  // Hook-level callbacks fire even if the modal unmounts under the screen's spinner while the details refetch.
  const { isLoading, mutate: confirmOrderApi } = useConfirmOrderApi({
    onSuccess: () => onClose(),
    // The order moved under us: the hook has toasted and refetched, nothing left to act on here.
    onError: (error) => {
      if (error.response?.status === 409) onClose();
    },
  });

  const onConfirm = () => {
    confirmOrderApi({ orderId });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='sm' closeOnOverlayClick={!isLoading} closeOnEsc={!isLoading}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Order</ModalHeader>
        <ModalCloseButton isDisabled={isLoading} />
        <ModalBody>
          <Text fontSize='md' color='gray.500'>
            Confirm order {code}? The restaurant will be notified.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant='outline' colorScheme='red' me='sm' onClick={onClose} isDisabled={isLoading}>
            Back
          </Button>
          <Button variant='solid' colorScheme='red' onClick={onConfirm} isLoading={isLoading}>
            Confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
